import { CircularProgress } from '@mui/material'
import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router';
import withAlert from '../../../hoc/withAlert';
import portalServices from '../portalService';
import CheckInWithSms from './CheckInWithSms';


function CheckinControllerPage({AppAlert}) {

    let { queueId } = useParams();
    const [queueDetails,setQueueDetails] = useState(null);

    const getQueueDetails = () =>{
        portalServices.getPortalQueueDetails(queueId).then(res=>{
            setQueueDetails(res.data.queueDetails);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    useEffect(()=>{
        getQueueDetails();
    },[queueId])

    return (
        <>
            { queueDetails == null ?
                <div className="mt-5 text-center"><CircularProgress/></div>
                :
                <CheckInWithSms queueDetails={queueDetails} />
            }
        </>
    )
}

export default withAlert(CheckinControllerPage)

